const MAP_MANUAIS = [
  {
    name: "Aquário",
    slug: "aquario",
    link: "https://mkt.cobasi.com.br/emails/2024/Ebook/Como_montar_meu_primeiro_aquario.pdf",
    group: "peixes",
    title: "para aquarismo",
    description: "para amantes de peixes"
  }
];

const MAP_MANUAIS_GROUPS = [
  // {
  //   name: "Cachorro",
  //   id: "cachorro",
  //   manuais: MAP_MANUAIS.filter((item) => item.group === "cachorro")
  // },
  // {
  //   name: "Gatos",
  //   id: "gatos",
  //   manuais: MAP_MANUAIS.filter((item) => item.group === "gatos")
  // },
  // {
  //   name: "Pássaros",
  //   id: "passaros",
  //   manuais: MAP_MANUAIS.filter((item) => item.group === "passaros")
  // },
  {
    name: "Peixes",
    id: "peixes",
    manuais: MAP_MANUAIS.filter((item) => item.group === "peixes")
  }
  // {
  //   name: "Outros Pets",
  //   id: "outros-pets",
  //   manuais: MAP_MANUAIS.filter((item) => item.group === "outros-pets")
  // },
  // {
  //   name: "Casa",
  //   id: "casa",
  //   manuais: MAP_MANUAIS.filter((item) => item.group === "casa")
  // },
  // {
  //   name: "Jardim",
  //   id: "jardim",
  //   manuais: MAP_MANUAIS.filter((item) => item.group === "jardim")
  // },
  // {
  //   name: "Piscina",
  //   id: "piscina",
  //   manuais: MAP_MANUAIS.filter((item) => item.group === "piscina")
  // }
];

export { MAP_MANUAIS, MAP_MANUAIS_GROUPS };
